import { useNavigate, useParams } from "react-router-dom"
import { useDispatch } from "react-redux"
import { useEffect, useState } from "react"
import { useFetchTableValueQuery } from "../../../api/rtk/base/slices/tablesApiSlice"
import { showToastMessage } from "../../../stateManagement/reducers"
import ToastMessageContainer from "../../../widgets/toastMessageContainer/ToastMessageContainer"
import LoaderWrapper from "../../../widgets/loaderWrapper/LoaderWrapper"
import TableWidget from "../../../widgets/table/tableWidget/TableWidget"
import { prepareTableData } from "../../../features/dataFormatFunctions/dataFormatter"
import { configureTableLazyState, defineTableColumnsFromArray, defineTableFilters } from "../../../widgets/table/tableFeatures/tableFunctions"
import ContentHeader from "../../../widgets/contentHeader/ContentHeader"
import { DataTableSelectEvent } from "primereact/datatable"

const columnsStructure: any = [
    {
        headerName: "Кадастровый номер части участка",
        field: "SubLotCadastralNumber",
        align: "center",
        valueType: "string"
    },
    {
        headerName: "Вид обременения",
        field: "EncumbranceTypeName",
        align: "center",
        valueType: "string",
    },
    {
        headerName: "Тип зоны",
        field: "TerritorialZoneString",
        align: "center",
        valueType: "string",
    },
    {
        headerName: "Наименование зоны по документу",
        field: "NameZone",
        align: "center",
        valueType: "string",
    },
    {
        headerName: "Номер зоны",
        field: "NumberZone",
        align: "center",
        valueType: "string",
    },
    {
        headerName: "Документ-основание",
        field: "RightEstablishmentDocuments",
        align: "left",
        valueType: "string",
    },
]

export default function TableLandLotEncumbrances() {
    const objectTypeName = "Encumbrances"
    const { landLotId } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate();
    const [tableState, setTableState] = useState<any>(null)
    const [tableValue, setTableValue] = useState<any>([])
    const [columns, setColumns] = useState<any>([])

    const { data: encumbrances, isFetching: isFetchingEncumbrances, isError: isErrorEncumbrances } = useFetchTableValueQuery({
        tableValueUrl: "objects/Encumbrances",
        filterStringArray: [`LandLotId eq ${landLotId}`],
        pages: true
    }, { skip: !landLotId })

    useEffect(() => {
        let columns = defineTableColumnsFromArray(columnsStructure)
        let filters = defineTableFilters(columns)
        setColumns(columns)
        setTableState(configureTableLazyState({ filters }))
    }, [])

    useEffect(() => {
        if (encumbrances && columns) {
            let value = encumbrances?.value
            value = prepareTableData(value, columns)
            setTableValue(value)
        }
    }, [encumbrances, columns])

    useEffect(() => {
        if (isErrorEncumbrances) {
            dispatch(showToastMessage({ messageText: "Ошибка загрузки таблицы", messageType: "error" }))
        }
    }, [isErrorEncumbrances])

    // function onRowSelect(event: DataTableSelectEvent) {
    //     navigate(`/app/table/LandSubLots/${event.data.SubLotID}`);
    // }

    return (
        <>
            <ContentHeader title="Ограничения (обременения) земельного участка" type="simple" />
            <div className="table-widget-with-toast with-content-header">
                <ToastMessageContainer />
                <LoaderWrapper isLoading={isFetchingEncumbrances} >
                    <TableWidget
                        tableValue={tableValue}
                        tableState={tableState}
                        columns={columns}
                        pageSize={100}
                        withTitleRow
                        // onRowSelect={onRowSelect}
                    />
                </LoaderWrapper>
            </div>
        </>
    )
}
